import { PayloadAction } from '@reduxjs/toolkit';
import { ProjectStateReducerCreator } from '../types';

const setIsCreatingNewSessionReducer = (create: ProjectStateReducerCreator) => {
  return create.reducer((state, action: PayloadAction<boolean>) => {
    state.isCreatingNewSession = action.payload;
  });
};

export default setIsCreatingNewSessionReducer;
